import React, { useState, useRef, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { Messages } from "primereact/messages";
import Swal from "sweetalert2";
import { axiosWithHeaders } from "../../../store/constants/axiosWrapper";

import { UPDATE_AREA_EVENT_TARGET } from "../../../store/constants/serviceEndpoint";
import * as enums from "../../../common/enum";
export default function ConfigTargetWithArea({
  eventId = 0,
  data = [],
  onReloadData = () => {},
}) {
  const refMessage = useRef(null);
  const [item, setItem] = useState(null);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   return () => {
  //     setItem(null);
  //     setVisible(false);
  //   }
  // }, [])

  const updateItem = (e, item) => {
    e.preventDefault();
    setItem(item);
    setVisible(true);
  };

  const cellTemplate = (row, column) => {
    // console.log(row)
    const field = column.field;
    switch (field) {
      case "createStore":
        return (
          <div
            style={{
              width: "100%",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            <InputSwitch checked={row.createStore} disabled />
          </div>
        );
      case "isLayer":
        return (
          <div
            style={{
              width: "100%",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            <InputSwitch checked={row.isLayer} disabled />
          </div>
        );
      default:
        return (
          <div
            style={{
              width: "100%",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            <Button
              icon="pi pi-pencil"
              className="p-button-success p-button-raised"
              style={{ marginRight: 7, width: 35 }}
              onClick={(e) => updateItem(e, row)}
            />
          </div>
        );
    }
  };

  const checkData = (obj) => {
    for (var field in obj) {
      if (
        obj[field] === undefined ||
        obj[field] === null ||
        obj[field] === "" ||
        obj[field] === 0
      ) {
        switch (field) {
          case "Target":
            refMessage.current.show({
              severity: "error",
              summary: "Lỗi",
              detail: "Vui lòng nhập chỉ tiêu !",
            });
            break;
          default:
            break;
        }
        return false;
      }
    }
    return true;
  };

  const onUpdateData = (e) => {
    e.preventDefault();
    let obj = {};
    obj.Target = item.target;
    const check = checkData(obj);
    if (check) {
      obj.AreaId = item.areaId;
      obj.EventId = eventId;
      obj.CreateStore = item.createStore;
      obj.IsLayer = item.isLayer;
      obj.Id = item.id;
      obj.CreatedBy = 0;
      setLoading(true);
      axiosWithHeaders("post", UPDATE_AREA_EVENT_TARGET, obj)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.status === enums.RESPONSE_OK
          ) {
            const { status, message } = response.data;
            if (status === enums.RESPONSE_OK) {
              Swal.fire("Thông báo", "Cập nhật thành công", "success");
              setItem(null);
              setVisible(false);
              if (typeof onReloadData === "function") onReloadData(eventId);
            } else {
              Swal.fire("Lỗi", message, "error");
            }
          }
        })
        .catch((err) => {
          Swal.fire("Lỗi", err.toString(), "error");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const footer = (
    <>
      <Button
        label="Cập nhật"
        icon="pi pi-check"
        onClick={onUpdateData}
        loading={loading}
        className="p-button-raised p-button-info"
      />
      <Button
        label="Hủy"
        className="p-button-raised p-button-secondary"
        icon="pi pi-times"
        loading={loading}
        onClick={() => {
          setItem(null);
          setVisible(false);
        }}
      />
    </>
  );

  return (
    <>
      <div className="row">
        <div
          className={`col-md-12 d-flex align-items-center position-relative justify-content-center`}
          style={{ fontSize: `1.5rem`, color: `red`, fontWeight: 700 }}
        >
          CÀI ĐẶT CHỈ TIÊU THEO VÙNG
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <DataTable
            value={data}
            emptyMessage="Hoạt động này chưa tạo hình nào...."
            style={{ marginTop: "30px" }}
          >
            <Column field="areaName" header="Tên vùng" />
            <Column field="target" header="Chỉ tiêu" />
            <Column
              field="createStore"
              header="Tạo cửa hàng"
              body={(row, column) => cellTemplate(row, column)}
              style={{ width: 120 }}
              className={"p-col-fixed"}
            />
            <Column
              field="isLayer"
              header="Lưu nháp"
              body={(row, column) => cellTemplate(row, column)}
              style={{ width: 120 }}
              className={"p-col-fixed"}
            />
            <Column
              body={(row, column) => cellTemplate(row, column)}
              style={{ width: 120 }}
              className={"p-col-fixed"}
            />
          </DataTable>
        </div>
      </div>
      <Dialog
        header={"Cài đặt chỉ tiêu theo vùng".toUpperCase()}
        footer={footer}
        visible={visible}
        style={{ width: 600 }}
        modal={true}
        onHide={() => {
          setVisible(false);
          setItem(null);
        }}
      >
        <div className="row mt-2">
          <div className="col-md-12">
            <Messages ref={refMessage} style={{ width: "100%" }} />
          </div>
        </div>
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-4 align-self-center text-right">
            <label htmlFor="txtTarget">Chỉ tiêu</label>
          </div>
          <div className="col-md-4">
            <InputText
              id="txtTarget"
              placeholder="0"
              style={{ width: "100%", color: "red", textAlign: "right" }}
              onChange={(e) => setItem({ ...item, target: e.target.value })}
              value={item && item.target ? item.target : ""}
            />
          </div>
        </div>
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-4 align-self-center text-right">
            <label>Tạo STORE SFA</label>
          </div>
          <div className="col-md-4 d-flex align-items-center">
            <InputSwitch
              checked={item && item.createStore ? item.createStore : false}
              onChange={(e) => setItem({ ...item, createStore: e.value })}
            />
          </div>
        </div>
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-4 align-self-center text-right">
            <label>Cho phép lưu nháp</label>
          </div>
          <div className="col-md-4 d-flex align-items-center">
            <InputSwitch
              checked={item && item.isLayer ? item.isLayer : false}
              onChange={(e) => setItem({ ...item, isLayer: e.value })}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
}
